module.exports = __webpack_public_path__ + "02de388a09abb1b2a972d95a6a5e498b.svg";